<template>
  <div>
    <div class="columns is-desktop">
      <div class="column is-half-desktop is-two-thirds-tablet">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                lead #
              </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>
              <span
                v-else
                class="has-text-grey"
              >
                {{ lead.id }}
              </span>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                Account
              </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <router-link
                  v-if="lead.account && Object.keys(lead.account).includes('id')"
                  :to="{ name: 'ViewAccount', params: { accountId: lead.account.id } }"
                  class="has-text-info has-text-weight-semibold"
                >
                  {{ lead.account.name }}
                </router-link>
              </template>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                Contact
              </p>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <router-link
                  v-if="lead.primaryContact"
                  :to="{ name: 'ViewContact', params: { contactId: lead.primaryContact.id } }"
                  class="has-text-info has-text-weight-semibold"
                >
                  {{
                    `${lead.primaryContact.firstName} ${lead.primaryContact.lastName}`
                  }}
                </router-link>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-half-desktop is-two-thirds-tablet">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                lead source
              </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.leadsSource"
                  class="has-text-grey"
                >
                  {{ lead.leadsSource.value }}
                </span>
              </template>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                temperature
              </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.temperature"
                  class="has-text-grey"
                >
                  {{ lead.temperature.value }}
                </span>
              </template>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                status
              </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.stage"
                  class="has-text-grey"
                >
                  {{ lead.stage.value.replace('Qualifed', 'Contacted') }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="divider">

    <div class="columns">
      <div class="column is-two-thirds-tablet">
        <div class="content">
          <h4 class="subtitle has-text-primary is-capitalized">
            Custom Fields
          </h4>
        </div>
        <div
          v-for="(item, key) in customFieldsList"
          :key="key"
          class="level is-mobile"
        >
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                {{ item.label }}
              </p>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.customFieldEntries"
                  class="has-text-grey"
                >
                  <template
                    v-if="lead.customFieldEntries
                      .filter((i) => i.customField.id === item.id).length > 0"
                  >
                    <template v-if="item.type === 'CURRENCY'">
                      {{ lead.customFieldEntries.filter(
                        (i) => i.customField.id === item.id)[0].value | currency }}
                    </template>
                    <template v-else>
                      {{ lead.customFieldEntries
                        .filter((i) => i.customField.id === item.id)[0].value.split(',').length > 1
                        ? lead.customFieldEntries
                          .filter((i) => i.customField.id === item.id)[0].value.split(',')
                          .join(', ')
                        : lead.customFieldEntries
                          .filter((i) => i.customField.id === item.id)[0].value }}
                    </template>
                  </template>
                  <template
                    v-else
                  >
                    {{ '--' }}
                  </template>
                </span>
                <span
                  v-else
                  class="has-text-grey"
                >
                  {{ '-' }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="divider">

    <div class="columns">
      <div class="column is-two-thirds-tablet">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                Opportunity Type
              </p>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.leadTypes.length > 0"
                  class="has-text-grey"
                >
                  {{ lead.leadTypes.map(i => i.lookup.value).join(", ") }}
                </span>
                <span
                  v-else
                  class="has-text-grey"
                >
                  --
                </span>
              </template>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                Bid Due Date
              </p>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else />
              <span
                v-if="lead.estimatedPotentials && lead.estimatedPotentials.bidDueDate"
                class="has-text-grey"
              >
                {{ lead.estimatedPotentials.bidDueDate | date }}
              </span>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                Est. Booking Date
              </p>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.estimatedPotentials
                    && lead.estimatedPotentials.estBookingDate"
                  class="has-text-grey"
                >
                  {{ lead.estimatedPotentials.estBookingDate | date }}
                </span>
              </template>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                Est. Install Date
              </p>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.estimatedPotentials
                    && lead.estimatedPotentials.estInstallDate"
                  class="has-text-grey"
                >
                  {{ lead.estimatedPotentials.estInstallDate | date }}
                </span>
              </template>
            </div>
          </div>
        </div>

        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="has-text-weight-bold is-capitalized">
                Est. Invoice Date
              </p>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <span
                v-if="isLoading"
                style="width: 120px"
              >
                <b-skeleton :animated="true" />
              </span>

              <template v-else>
                <span
                  v-if="lead.estimatedPotentials
                    && lead.estimatedPotentials.estInvoiceDate"
                  class="has-text-grey"
                >
                  {{ lead.estimatedPotentials.estInvoiceDate | date }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadsDetails',

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },

    lead: {
      type: Object,
      required: true,
    },

    customFieldsList: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="css" scoped></style>
